import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EditWhite, Star } from '../../img';
import { Modal } from 'components';
import ImageUploader from 'react-images-upload';
import { Link } from 'react-router';
import {
  getImages, deleteImage, getReviews, updateReview, deleteReview, setIconImageURL, removeImage
} from '../../ducks/integration';
import ContentLoader from 'react-content-loader';
import { confirmAlert } from 'react-confirm-alert';
import Dropdown from 'react-dropdown';

const TableRow = props => {
  const random = Math.random() * (1 - 0.7) + 0.7;
  return (
    <ContentLoader
      height={40}
      width={1060}
      speed={2}
      primaryColor="#fff"
      secondaryColor="#eceef4"
      {...props}
    >
      <rect x="0" y="15" rx="4" ry="4" width="6" height="6.4" />
      <rect x="38" y="13" rx="6" ry="6" width={40 * random} height="12" />
      <rect x="180" y="13" rx="6" ry="6" width={200 * random} height="12" />
      <rect x="230" y="13" rx="6" ry="6" width={78 * random} height="12" />
      <rect x="420" y="13" rx="6" ry="6" width={117 * random} height="12" />
      <rect x="690" y="13" rx="6" ry="6" width={83 * random} height="12" />
      <rect x="830" y="13" rx="6" ry="6" width={63 * random} height="12" />
      <rect x="1000" y="13" rx="6" ry="6" width={63 * random} height="12" />
      <rect x="0" y="39" rx="6" ry="6" width="1060" height=".3" />
    </ContentLoader>
  );
};

let starImg = <img className='drop-strs' src={Star} />;
const ratingOption = [
  { value: '1', label: <div>{starImg}</div> },
  { value: '2', label: <div>{starImg}{starImg}</div> },
  { value: '3', label: <div>{starImg}{starImg}{starImg}</div> },
  { value: '4', label: <div>{starImg}{starImg}{starImg}{starImg}</div> },
  { value: '5', label: <div>{starImg}{starImg}{starImg}{starImg}{starImg}</div> }
];
class Review extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stul: '',
      img: '',
      dn: '',
      desc: '',
      intISActive: false,
      usIntId: '',
      in: '',
      openClose: false,
      hideShowDrp: false,
      intDropUniq: '',
      un: '',
      rmk: '',
      searchGMBPG: '',
      lng: 'en',//Google place review language
      place_id: '',
      isDisable: false,
      searchByApp: '',
      curl: '',//Product URL for capterra
      filterIntType: '',//Review or feed
      t: '',//Webhook type
      tl: '',//Database tooltip
      webhookURL: '',//For Copy endpoint
      slug: '',//twitter slug name
      widgetListData: [],
      islstIntLoading: false,
      isIntegration: false,
      isAPICall: false,
      isOpenCloseFilter: false,
      itwtpst: false,//Filter Show original tweet
      itwtrpls: false,//Filter Show reply tweet
      itwtrtwt: false,//Filter Show re-tweet
      twitterUNid: '',
      isFromInt: '',//For Twitter Update dataSource
      isAllInOne: false,//For Show search box when widget is all in One
      searchByName: '',//Search by google location name
      isHideShowInt: false,//Hide Show integration div
      openCloseSideDataPanel: false,//Hide show review data side panel
      isLoaderForReviewDiv: false,//Loader for review slider
      reviewDataItems: [],//Store review Data
      pageNoReview: 0,//Page Number For Review
      reviewFuid: '',//When Edit Integration store Integration id
      totalCountOfData: 0,//No of review count
      openCloseData: false,
      msg: '',
      rtxt: '',
      rtng: '5',
      fuid: '',
      openCloseIconModel: false,
      iconLable: '',
      cptntxt: '',
      wbstlnk: '',
      wbstlg: '',
      dnForEditRevie: '',
      iconLoader: false,
      wbstlg1: '',
      reviewPgId: '',
      openCloseSideCustomPanel: false,
      openCloseSideCustomData: false,
      isAddnewRec: false,
      isExcelDownload: false,
      openCloseCustomWBPanel: false,
      custkeyword: '',
      custvalue: '',
      epURL: '',
      pgid: '',
      ak: '',
      dname: '',
      puak: '',//Public API Key
      prak: '',//Private API Key
      sh: '',//Store hash
      stpd: '',//Product id
      isCallInterVal: false
    };
  }

  componentDidMount() {
    console.log(this.props.state.usIntObj);
    this.state.openCloseSideDataPanel = true;
    this.state.isLoaderForReviewDiv = true;
    this.state.pageNoReview = 1;
    this.state.reviewFuid = this.props.state.usIntObj._id;
    this.state.dnForEditRevie = this.props.state.usIntObj.rmk;
    this.setState(this.state);
    let objPgn = {
      id: this.props.state.usIntObj._id,
      pn: 1,
      cl: 0,
      in: this.props.state.usIntObj.inm
    };
    if (this.props.state.usIntObj && this.props.state.usIntObj.pgObj) {
      if (this.props.state.usIntObj.inm == 'googlemybusiness') {
        objPgn.pgid = this.props.state.usIntObj.pgObj.name;
        this.state.reviewPgId = this.props.state.usIntObj.pgObj.name;
        this.setState(this.state);
      }
      if (this.props.state.usIntObj.inm == 'facebook') {
        objPgn.pgid = this.props.state.usIntObj.pgObj.id;
        this.state.reviewPgId = this.props.state.usIntObj.pgObj.id;
        this.setState(this.state);
      }
    }
    this.props.getImages();
    this.props.getReviews(objPgn);
    // this.props.getReviews(searchQRY);
    // this.props.getUserIntegration({ type: 'review' });
  }

  componentDidUpdate(prevProps) {
    console.log(this.props);
    if ((this.props.reviewsData && this.props.reviewsData.data) != (prevProps.reviewsData && prevProps.reviewsData.data)) {
      this.state.reviewDataItems = [...this.props.reviewsData.data, ...this.state.reviewDataItems];
      if (this.props.reviewsData.count) {
        this.state.totalCountOfData = this.props.reviewsData.count;
      }
      if (this.props.reviewsData.count && this.props.reviewsData.count > 11) {
        document.getElementById('edit_scroll').style.height = '83vh';
        document.getElementById('edit_scroll').style.overflowY = 'scroll';
      }
      this.state.isLoaderForReviewDiv = false;
      this.setState(this.state);
    }
    if (this.props.iconImages != prevProps.iconImages) {
      this.state.iconLoader = false;
      this.setState(this.state);
    }
    if (this.props.deleteReviewID != prevProps.deleteReviewID) {
      this.props.fnGetWidgetData();
    }
    if (this.props.updReview != prevProps.updReview) {
      this.props.fnGetWidgetData();
    }
    if (this.props.excelDownload != prevProps.excelDownload) {
      this.setState({
        isExcelDownload: false
      });
    }
  }

  uploadIconfile = (id) => {
    if (this.state.wbstlg1 && this.validURL(this.state.wbstlg1) == false) {
      this.updateReview(id, 'iconUpload');
    }
  }

  base64FileURL = (element, callback) => {
    let file = element;
    let reader = new window.FileReader();
    reader.onloadend = function (e) {
      callback(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  handleReviewImgChange = (file) => {
    //convert image in base64 file
    if (file && file.length > 0) {
      this.base64FileURL(file[0], (obj) => {
        //this.state.wbstlg = obj;
        this.state.wbstlg1 = obj;
        this.state.iconLable = file[0].name;
        this.setState(this.state);
      });
    }
  }

  deleteImage = (id, iu) => {
    this.state.iconLoader = true;
    this.setState(this.state);
    let obj = {
      id: id, wbstlnk: iu
    };
    this.props.deleteImage(obj);
  }

  iconModelCont = () => {
    return (
      <div className="modal-body wdgt-icon-setting">
        <div className="mdl-icon-upload">
          {/* <input className="input_files" id="review_img_upload" onChange={(e) => this.handleReviewImgChange(e.target.files[0])} type="file" name="file" />
          <input className="nf-btn nf-btn-default  nf-btn-min15x" type='button' value='UPLOAD'
            onClick={() => this.uploadIconfile(this.state.fuid)} /> */}
          <ImageUploader
            className='simpple'
            fileContainerStyle={{ padding: 0, display: 'block', background: 'rgba(0,0,0,0)', WebkitBoxShadow: 'none', boxShadow: 'none', margin: 0 }}
            buttonClassName=''
            buttonStyles={{}}
            withIcon={false}
            withLabel={true}
            label={this.state.iconLable ? this.state.iconLable : ''}
            labelStyles={{ float: 'right' }}
            buttonText='Browse'
            singleImage={true}
            onChange={this.handleReviewImgChange}
            imgExtension={['.jpg', '.jpeg', '.png', '.svg', '.gif']}
            maxFileSize={5242880} />
          <input className="nf-btn nf-btn-default nf-btn-min15x nf-btn-minW" type='button' value='UPLOAD'
            onClick={() => this.uploadIconfile(this.state.fuid)} />
        </div>
        {this.state.iconLoader == true ?
          <ContentLoader
            height={450}
            width={700}
            speed={2}
            primaryColor="#eceef4"
            secondaryColor="#fff">
            <rect x="20" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="110" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="200" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="290" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="380" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="470" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="560" y="25" rx="0" ry="0" width="75" height="75" />

            <rect x="20" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="110" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="200" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="290" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="380" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="470" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="560" y="115" rx="0" ry="0" width="75" height="75" />

            <rect x="20" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="110" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="200" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="290" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="380" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="470" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="560" y="205" rx="0" ry="0" width="75" height="75" />

            <rect x="20" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="110" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="200" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="290" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="380" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="470" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="560" y="295" rx="0" ry="0" width="75" height="75" />
          </ContentLoader> :
          <div className="wdgt-iconmodal-block">
            {
              this.props.iconImages && this.props.iconImages.map((val, key) => {
                return (
                  <div className="icon-gallery-item" key={key}>
                    <div className="icon-gallery-box">
                      <span className="tbl-action-dlt action-dlt-icongallery"
                        onClick={() => this.deleteImage(val._id, val.iu)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                          <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                            <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                            <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                          </g>
                        </svg>
                      </span>
                      <img src={val.iu} style={{ height: '150px', width: '150px' }} alt="icon"
                        onClick={() => this.setIconImageURL(val.iu)} />
                    </div>
                  </div>
                );
              })
            }
          </div>}

      </div>
    );
  }

  closeIconModel = () => {
    this.setState({ openCloseIconModel: false });
  }

  openIconModel = (id) => {
    this.setState({ openCloseIconModel: true, fuid: id, iconLoader: false });
  }

  closeModalData = () => {
    this.state.cptntxt = '';
    this.state.msg = '';
    this.state.rtxt = '';
    this.state.wbstlnk = '';
    this.state.wbstlg1 = '';
    this.state.wbstlg = '';
    this.state.fuid = '';
    this.state.openCloseData = false;
    this.setState(this.state);
  }

  //handle state change
  handleStateChangeInt = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  deleteReview = (id, fuid) => {
    let index = this.state.reviewDataItems.findIndex(x => x._id == id);
    var array = this.state.reviewDataItems;
    if (index > -1) {
      array.splice(index, 1);
    }
    let obj = {
      id: id,
      fuid: fuid
    };
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>by clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.state.reviewDataItems = array;
                this.state.totalCountOfData = this.state.totalCountOfData - 1;
                this.setState(this.state);
                this.props.deleteReview(obj);
                onClose();
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
      }
    });
  }

  validURL = (str) => {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  editReview = (obj) => {
    this.setState({
      un: obj.un,
      msg: obj.msg,
      rtxt: obj.rtxt,
      rtng: obj.rtng ? obj.rtng.toString() : '1',
      fuid: obj._id,
      cptntxt: obj.cptntxt,
      pgid: obj.pgid,
      wbstlnk: obj.wbstlnk,
      wbstlg: this.validURL(obj.wbstlg) == true ? obj.wbstlg : '',
      openCloseData: true
    });
  }

  updateReview = (data, from) => {
    this.state.iconLoader = true;
    this.setState(this.state);
    if (from == 'iconUpload') {
      let obj = {
        _id: this.state.fuid,
        wbstlg: this.state.wbstlg1,
        fuid: this.state.reviewFuid
      };
      this.state.pageNoReview = 1;
      this.state.reviewDataItems = [];
      this.state.totalCountOfData = 0;
      this.setState(this.state);
      this.props.updateReview(obj);
    } else if (from == 'updateBtn') {
      this.state.reviewDataItems.filter(x => {
        if (x._id == data) {
          x.cptntxt = this.state.cptntxt;
          x.wbstlnk = this.state.wbstlnk;
          x.wbstlg = this.state.wbstlg;
          x.un = this.state.un;
          x.rtng = this.state.rtng;
          x.msg = this.state.msg;
          x.rtxt = this.state.rtxt;
          x.pgid = this.state.pgid;
        }
        return x;
      });
      let obj = {
        _id: this.state.fuid,
        cptntxt: this.state.cptntxt,
        wbstlnk: this.state.wbstlnk,
        wbstlg: this.state.wbstlg,
        un: this.state.un,
        rtng: this.state.rtng,
        msg: this.state.msg,
        rtxt: this.state.rtxt,
        fuid: this.state.reviewFuid,
        pgid: this.state.pgid
      };
      this.state.iconLable = '';
      this.state.iconLable = '';
      if (from == 'updateBtn') {
        this.state.openCloseData = false;
        this.state.iconLoader = true;
        this.state.wbstlg = '';
        this.state.wbstlg1 = '';
        this.state.un = '';
        this.state.cptntxt = '';
        this.state.wbstlnk = '';
        this.state.rtng = '5';
        this.state.fuid = '';
        this.state.msg = '';
        this.state.rtxt = '';
        this.state.pageNoReview = 1;
        this.state.reviewDataItems = [];
        this.state.totalCountOfData = 0;
      }
      this.setState(this.state);
      this.props.updateReview(obj);
    }
    // console.log(data, '===data');
    // this.state.iconLoader = true;
    // this.setState(this.state);
    // this.state.reviewDataItems.filter(x => {
    //   if (x._id == data) {
    //     x.cptntxt = this.state.cptntxt;
    //     x.wbstlnk = this.state.wbstlnk;
    //     x.wbstlg = this.state.wbstlg1 ? this.state.wbstlg1 : this.state.wbstlg;
    //   }
    //   return x;
    // });
    // let obj = {
    //   _id: this.state.fuid,
    //   cptntxt: this.state.cptntxt,
    //   wbstlnk: this.state.wbstlnk,
    //   wbstlg: this.state.wbstlg1 ? this.state.wbstlg1 : this.state.wbstlg
    // };
    // this.state.iconLable = '';
    // if (from == 'updateBtn') {
    //   this.closeModalData();
    //   this.state.wbstlg = '';
    //   this.state.wbstlg1 = '';
    // }
    // this.setState(this.state);
    // this.props.updateReview(obj);
  }

  closeDataPanel = () => {
    if (this.state.fuid == '') {
      this.state.openCloseData = false;
      this.state.openCloseSideDataPanel = false;
      this.state.cptntxt = '';
      this.state.wbstlnk = '';
      this.state.wbstlg1 = '';
      this.state.wbstlg = '';
      this.state.fuid = '';
      this.state.pageNoReview = 1;
      this.state.reviewDataItems = [];
      this.state.totalCountOfData = 0;
      this.setState(this.state);
    }
  }

  setIconImageURL = (iu) => {
    this.state.wbstlg = iu;
    this.state.openCloseIconModel = false;
    this.setState(this.state);
    // let obj = {
    //   id: this.state.fuid,
    //   cptntxt: this.state.cptntxt,
    //   wbstlnk: this.state.wbstlnk,
    //   wbstlg: iu
    // };
    // this.updateReview(this.state.fuid);
    //this.props.setIconImageURL(obj);
  }

  removeImage = () => {
    // let obj = {
    //   id: this.state.fuid
    // };
    this.state.wbstlg = '';
    this.state.wbstlg1 = '';
    this.setState(this.state);
    //this.props.removeImage(obj);
  }

  render() {
    console.log(this.props.reviewDataItems);
    return (
      <div>
        <div className="intrag-review-wrap  222">
          <div className="edit-review-wrapper">
            {this.state.openCloseData == true &&
              <div className="edit-review-content">

                <div className="edit-review-header" onClick={() => this.closeModalData()}>
                  <svg className="link-svg " xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 12 20">
                    <path id="collsapn-arrow" d="M11.587,10.928,2.565,19.951a1.111,1.111,0,0,1-1.568,0l-.665-.665a1.111,1.111,0,0,1,0-1.568L7.909,10.14.324,2.557a1.111,1.111,0,0,1,0-1.568L.988.324a1.111,1.111,0,0,1,1.568,0l9.03,9.03a1.12,1.12,0,0,1,0,1.574Z" transform="translate(11.894 20) rotate(-177)" fill="#8FA7C4" />
                  </svg>
                  <div className="title-dataset-label cursor">
                    <h6 className='sidepanel-integration-title' style={{ textTransform: 'capitalize' }}>{this.state.un}</h6>
                  </div>
                </div>
                {this.state.iconLoader == true && this.state.openCloseIconModel == false ?
                  Array(10)
                    .fill('')
                    .map((e, i) => (
                      <TableRow key={i} style={{ opacity: Number(2 / i).toFixed(1) }} />
                    )) :
                  <div className="edit-review-elementor">
                    <form className="edit-review-form">
                      <div className="nf-group-input">
                        <label>Name</label>
                        <input type="text"
                          name="un"
                          className="editor-input-content editor-input-fullwidth"
                          id=""
                          placeholder='Name'
                          value={this.state.un}
                          onChange={(e) => this.handleStateChangeInt(e)}
                        />
                      </div>
                      <div className="nf-group-input">
                        <label>Ratings</label>
                        <Dropdown
                          className="nf-select-dropdown nf-select-defaultdd  nf-select-conditondd nf-select-desgn"
                          name="rtng"
                          options={ratingOption}
                          value={this.state.rtng}
                          onChange={(e) => this.handleInputchange('rtng', e)}
                        />
                      </div>
                      <div className="nf-group-input">
                        <label>Rating Text</label>
                        <textarea
                          name="rtxt"
                          className="editor-input-content editor-input-fullwidth"
                          id=""
                          cols="5"
                          rows="5"
                          placeholder='Rating Text'
                          value={this.state.rtxt}
                          onChange={(e) => this.handleStateChangeInt(e)}
                        >
                        </textarea>
                      </div>
                      <div className="nf-group-input">
                        <label>Caption</label>
                        <input type="text"
                          name="cptntxt"
                          className="editor-input-content editor-input-fullwidth"
                          id=""
                          placeholder='Caption'
                          value={this.state.cptntxt}
                          onChange={(e) => this.handleStateChangeInt(e)}
                        />
                      </div>
                      <div className="nf-group-input">
                        <label>Website URL</label>
                        <input type="text"
                          name="wbstlnk"
                          className="editor-input-content editor-input-fullwidth"
                          id=""
                          placeholder="Website URL"
                          value={this.state.wbstlnk}
                          onChange={(e) => this.handleStateChangeInt(e)}
                        />
                      </div>
                      <div className="nf-group-input">
                        <label>Website Logo</label>
                        <div className="nf-group-input">
                          <div className="icon-setting-block">
                            {
                              this.state.wbstlg ?
                                <div className="icon-box">
                                  <img
                                    className="editor-input-content"
                                    id=""
                                    src={this.state.wbstlg}
                                  />
                                  <span onClick={() => this.removeImage()} className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 17.181 17.09">
                                      <path id="Path_232" data-name="Path 232" d="M295.416,385.5l6.292-6.292a1,1,0,0,0-1.414-1.415L294,384.089l-6.292-6.292a1,1,0,1,0-1.415,1.415l6.293,6.292-6.293,6.292a1,1,0,0,0,1.415,1.415L294,386.92l6.293,6.292a1,1,0,0,0,1.414-1.415Zm0,0" transform="translate(-285.41 -376.914)" fill="#fb5360" stroke="#fb5360" stroke-width="1" />
                                    </svg>
                                  </span>
                                </div>
                                :
                                <div className="icon-box">
                                  <img
                                    className="editor-input-content"
                                    id=""
                                    src="https://storage.googleapis.com/widget_img/widget/default_share.png"
                                  />
                                </div>
                            }
                            <div className="icon-edit cursor" onClick={() => this.openIconModel(this.state.fuid)}>
                              <img src={EditWhite} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="nf-btn-reviewup text-center mt-20 edit-review-adddownload">
                      <button type='button' className="nf-btn nf-btn-white nf-btn-noneBdr nf-btn-cancel"
                        onClick={() => this.closeModalData()}>
                        Cancel
                      </button>
                      {this.state.isAddnewRec == false ?
                        <button type='button' className="nf-btn nf-btn-default nf-btn-noneBdr nf-bt-updsav"
                          onClick={() => this.updateReview(this.state.fuid, 'updateBtn')}>
                          Update
                        </button> :
                        <button type='button' className="nf-btn nf-btn-default nf-btn-noneBdr nf-bt-updsav"
                          onClick={() => this.addCutomReview()}>
                          Save
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            {/* edit review side panel */}
            {this.state.openCloseData == false &&
              <div className='edit-review-block'>
                <div className="rightbar-title">
                  <h4 className="sidepanel-integration-title">{this.state.dnForEditRevie ? this.state.dnForEditRevie : ''} Wall</h4>
                  {this.state.fuid == '' &&
                    <button className="btn-close-rightbar " onClick={() => this.props.viewReviewData(this.props.state.usIntObj, this.props.state.usIntObj.pgObj ? this.props.state.usIntObj.pgObj : '')}>
                      <svg className='brand-path-color' xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 9.99">
                        <path id="Path_59483" data-name="Path 59483" d="M-440.148-160.721l3.3-3.3a1,1,0,0,0,0-1.407,1.019,1.019,0,0,0-1.408,0l-3.3,3.3-3.3-3.3a1.017,1.017,0,0,0-1.405,0,.986.986,0,0,0-.292.7.988.988,0,0,0,.292.7l3.3,3.3-3.3,3.3a.987.987,0,0,0-.292.7.988.988,0,0,0,.292.7,1,1,0,0,0,1.406,0l3.3-3.3,3.3,3.3a1,1,0,0,0,.7.291.992.992,0,0,0,.7-.291,1,1,0,0,0,0-1.407Z" transform="translate(446.554 165.712)" fill="#645cfc" />
                      </svg>
                    </button>}
                </div>
                <ul className='edit-review-list' id='edit_scroll'>

                  {
                    this.state.reviewDataItems && this.state.reviewDataItems.length > 0 ?
                      this.state.reviewDataItems.map((obj, i) => {
                        return (
                          <li className='edit-review-item' key={i}>
                            <div className='edit-review-leftpart'>
                              <h5>{obj.fn ? obj.fn : '-'}</h5>
                              <p>{obj.rtxt ? obj.rtxt : '-'}</p>
                            </div>
                            <div className='edit-review-rightpart'>
                              {obj.fa !== 'customcollectorreview' &&
                                <Link onClick={() => this.editReview(obj)} className="btn-action nf-btn light-bg-icon btn-icon-30 tbl-action-dlt">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                                    <path id="Path_59457" data-name="Path 59457" d="M-656.586,37.444V44.3h-14v-13.7h7v1.37h-5.6V42.927h11.2V37.444Zm-9.1.214,5.615-5.508,1.089,1.4-5.682,5.954h-1.021Zm-1.4,3.213h3.02l6.935-7.322-2.9-3.252-7.053,6.78Z" transform="translate(670.586 -30.297)" fill="#8392a5" />
                                  </svg>
                                </Link>
                              }
                              <Link onClick={() => this.deleteReview(obj._id, obj.fuid)} className="btn-action nf-btn btn-delete-light light-bg-icon btn-icon-30 tbl-action-dlt">
                                <svg id="Group_29020" data-name="Group 29020" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                                  <rect id="Rectangle_135" data-name="Rectangle 135" width="1.264" height="5.509" transform="translate(7.785 5.664)" fill="#f06548" />
                                  <path id="Path_162" data-name="Path 162" d="M-127.23,5.132V2.295h-6.927V5.132H-137.7V6.386h2.122V16.3h9.755V6.386h2.123V5.132ZM-128.5,3.559V5.132h-4.41V3.559Zm-5.765,11.482V6.386h7.185v8.655Z" transform="translate(137.699 -2.295)" fill="#f06548" />
                                  <rect id="Rectangle_136" data-name="Rectangle 136" width="1.254" height="5.509" transform="translate(4.959 5.664)" fill="#f06548" />
                                </svg>
                              </Link>
                            </div>
                          </li>
                        );
                      })
                      :
                      <li className='edit-review-item'>
                        <div className="edit-review-leftpart">
                          <h5>No record found</h5>
                        </div>
                      </li>
                  }
                </ul>
                <div className='edit-review-adddownload'>
                  {this.state.in == 'customreview' && this.state.openCloseData == false &&
                    <button onClick={() => this.openAddDataModal()} className="nf-btn nf-btn-default nf-btn-noneBdr">
                      Add new Testimonial
                    </button>
                  }
                  {this.state.in == 'customreview' && this.state.openCloseData == false && this.state.reviewDataItems && this.state.reviewDataItems.length > 0 &&
                    < button onClick={this.downloadExcelData} disabled={this.state.isExcelDownload} className="nf-btn nf-btn-default nf-btn-noneBdr nf-btn-download">
                      Download
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <Modal
          id='iconModel'
          className='iconModel'
          title='Upload icon'
          content={this.iconModelCont()}
          openCloseModal={this.closeIconModel}
          style={
            {
              modalStyle: {
                display: this.state.openCloseIconModel ? 'block' : 'none',
                opacity: this.state.openCloseIconModel ? 1 : 0
              },
              alignModalStyle: {
                top: '210px'
              }
            }
          } />
      </div >
    );
  }
}

const mapStateToProps = state => ({
  loading: state.getIn(['loading', 'state']),
  reviewsData: state.getIn(['integration', 'reviewsData']),
  userIntegration: state.getIn(['reviews', 'userIntegration']),
  iconImages: state.getIn(['integration', 'iconImages']),
});

const mapDispatchToProps = {
  getReviews, updateReview, deleteReview, getImages, deleteImage, setIconImageURL, removeImage
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Review);
// import React, { Component } from 'react';
// import { connect } from 'react-redux';
// import {
//   getReviews, updateReview, deleteReviewData, deleteBulkReview,
//   getUserIntegration
// } from '../../ducks/reviews';
// import { confirmAlert } from 'react-confirm-alert';
// import DateRangePicker from 'react-bootstrap-daterangepicker';
// import ContentLoader from 'react-content-loader';
// import { IconDelete, NoDataImg } from '../../img';
// import { ReviewModel } from 'components';
// const moment = require('moment');
// import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
// import './Review.scss';

// const TableRow = props => {
//   const random = Math.random() * (1 - 0.7) + 0.7;
//   return (
//     <ContentLoader
//       height={40}
//       width={1060}
//       speed={2}
//       primaryColor="#fff"
//       secondaryColor="#eceef4"
//       {...props}
//     >
//       <rect x="0" y="15" rx="4" ry="4" width="6" height="6.4" />
//       <rect x="35" y="15" rx="4" ry="4" width="6" height="6.4" />
//       <rect x="80" y="13" rx="6" ry="6" width={200 * random} height="12" />
//       <rect x="300" y="13" rx="6" ry="6" width={117 * random} height="12" />
//       <rect x="465" y="13" rx="6" ry="6" width={200 * random} height="12" />
//       <rect x="705" y="13" rx="6" ry="6" width={117 * random} height="12" />
//       <rect x="865" y="13" rx="6" ry="6" width={83 * random} height="12" />
//       <rect x="985" y="13" rx="0" ry="0" width="45" height="15" />
//       <rect x="0" y="39" rx="6" ry="6" width="1060" height=".3" />
//     </ContentLoader>
//   );
// };

// let searchQRY = {};

// class Review extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       items: [],
//       pgNum: 1,
//       isLoading: false,
//       hasMore: false,
//       pagingCount: 0,
//       ocReview: false,
//       fn: '',
//       ln: '',
//       un: '',
//       rtng: '',
//       msg: '',
//       _id: '',
//       allSel: false,
//       delArry: [],
//       noOfRecord: 0,
//       tabIndex: 0,
//       isLoadMore: false,
//       searchUsername: '',
//       searchReviewText: '',
//       isDisabledTextBox: false,
//       startDate: '',//Picker start date
//       endDate: '',//Picker end date,
//       chipsData: ''//Selected data source value in chips
//     };
//   }

//   componentDidMount() {
//     searchQRY = {
//       pageNo: this.state.pgNum,
//       today: {
//         from: new Date().setHours(0, 0, 0, 0),
//         to: new Date().setHours(24, 0, 0, 0)
//       }
//     };
//     this.props.getReviews(searchQRY);
//     this.props.getUserIntegration({ type: 'review' });
//   }

//   componentDidUpdate(prevProps) {
//     if (prevProps.reviewsData !== this.props.reviewsData && this.props.reviewsData !== this.state.items) {
//       let { reviewsData } = this.props;
//       //page number one then store data count in the state
//       if (reviewsData && reviewsData.count) {
//         this.state.noOfRecord = reviewsData.count;
//         this.setState(this.state);
//       }
//       if (reviewsData && reviewsData.data && reviewsData.data.length === 0) {
//         this.state.hasMore = false;
//         this.state.isLoading = false;
//         this.setState(this.state);
//       }
//       else if (reviewsData && reviewsData.data && reviewsData.data.length > 0) {
//         if (reviewsData.data.length < 10) {
//           this.state.items = [...this.state.items, ...reviewsData.data];
//           this.state.hasMore = false;
//         }
//         else {
//           this.state.pagingCount = this.state.pagingCount + 10;
//           this.state.items = [...this.state.items, ...reviewsData.data];
//           this.state.hasMore = true;
//         }
//       }
//       this.state.isDisabledTextBox = false;
//       this.state.isLoading = false;
//       this.setState(this.state);
//     }
//   }

//   removeData = () => {
//     this.state.hasMore = true;
//     this.state.items = [];
//     this.setState(this.state);
//   }

//   //search review
//   searchReview = (e) => {
//     let code = e.keyCode || e.which;
//     if (code == 13) {
//       this.state.isDisabledTextBox = true;
//       this.getReviewsPG(this.state.tabIndex, 1);
//       this.setState(this.state);
//     }
//   }

//   //get
//   //get review with paging
//   getReviewsPG = (tabIndex, pageNo) => {
//     this.state.pgNum = pageNo;
//     this.state.tabIndex = tabIndex;
//     this.state.isLoadMore = true;
//     this.state.startDate = '';
//     this.state.endDate = '';
//     this.setState(this.state);
//     let fromApp = searchQRY['fa'];
//     //today data search query
//     if (tabIndex == 0) {
//       searchQRY = {};
//       searchQRY = {
//         pageNo: this.state.pgNum,
//         fa: fromApp,
//         searchUsername: this.state.searchUsername ? this.state.searchUsername : '',
//         searchReviewText: this.state.searchReviewText ? this.state.searchReviewText : '',
//         today: {
//           from: new Date().setHours(0, 0, 0, 0),
//           to: new Date().setHours(24, 0, 0, 0)
//         }
//       };
//     }
//     //all data search query
//     else if (tabIndex == 1) {
//       searchQRY = {};
//       searchQRY = {
//         pageNo: this.state.pgNum,
//         fa: fromApp,
//         searchUsername: this.state.searchUsername ? this.state.searchUsername : '',
//         searchReviewText: this.state.searchReviewText ? this.state.searchReviewText : ''
//       };
//     }
//     //change tab then old data remove and start to form the beginning
//     if (pageNo === 1) {
//       this.state.pagingCount = 0;
//       this.state.isLoading = true;
//       this.setState(this.state);
//       this.removeData();
//     }
//     this.props.getReviews(searchQRY);
//   }

//   //create
//   ///update
//   //update review
//   updateReview = (obj) => {
//     let { fn, ln, msg, rtng, un } = this.state;
//     this.props.updateReview({
//       fn: fn,
//       ln: ln,
//       rtng: rtng,
//       msg: msg,
//       _id: obj,
//       un: un
//     });
//   }

//   //delete
//   //delete single review data
//   deleteReviewData = (id) => {
//     confirmAlert({
//       closeOnEscape: false,
//       closeOnClickOutside: false,
//       customUI: ({ onClose }) => {
//         return (
//           <div className='custom-ui'>
//             <h1>Confirm to Delete</h1>
//             <p>Are you sure to do this.</p>
//             <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
//               onClick={() => {
//                 this.state.items = [];
//                 this.state.isLoading = false;
//                 this.state.pagingCount = 0;
//                 this.state.pgNum = 1;
//                 this.state.hasMore = false;
//                 this.setState(this.state);
//                 this.props.deleteReviewData(id);
//                 onClose();
//               }}>
//               Yes
//             </button>
//             <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
//               Cancel
//             </button>
//           </div>
//         );
//       }
//     });
//   }

//   //select multiple data to delete
//   deleteMulti = (_id, target) => {
//     let _index = this.state.delArry.findIndex(x => x._id == _id);
//     if (_index == -1) {
//       this.state.delArry.push({
//         _id: _id,
//         ia: target
//       });
//     }
//     else {
//       var index = _index;
//       var array = this.state.delArry;
//       if (index > -1) {
//         array.splice(index, 1);
//       }
//       this.state.delArry = array;
//       this.setState(this.state);
//     }
//     if (this.state.delArry.length == this.state.items.length) {
//       this.state.allSel = true;
//     }
//     else {
//       this.state.allSel = false;
//     }
//     this.setState(this.state);
//   }

//   //delete bluk review data
//   deleteBulk = () => {
//     let obj = { array: this.state.delArry };
//     confirmAlert({
//       closeOnEscape: false,
//       closeOnClickOutside: false,
//       customUI: ({ onClose }) => {
//         return (
//           <div className='custom-ui'>
//             <h1>Confirm to Delete</h1>
//             <p>Are you sure to do this.</p>
//             <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
//               onClick={() => {
//                 this.state.items = [];
//                 this.state.isLoading = false;
//                 this.state.pagingCount = 0;
//                 this.state.delArry = [];
//                 this.state.allSel = false;
//                 this.state.pgNum = 1;
//                 this.state.hasMore = false;
//                 this.setState(this.state);
//                 this.props.deleteBulkReview(obj), onClose();
//               }}>
//               Yes
//             </button>
//             <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
//               Cancel
//             </button>
//           </div>
//         );
//       }
//     });
//   }

//   //others
//   //initialize state
//   init = () => {
//     this.setState({ ocReview: false });
//   }

//   //close review model
//   closeModal = () => {
//     this.init();
//   }

//   //open review model
//   opReviewModel = (obj) => {
//     this.state = obj;
//     this.state.ocReview = true;
//     this.setState(this.state);
//   }

//   //handle state change
//   handleStateChange = (e) => {
//     if (e.target.name == 'searchUsername' && !e.target.value) {
//       this.state.items = [];
//       this.state.searchUsername = '';
//       this.state.isDisabledTextBox = true;
//       this.setState(this.state);
//       this.getReviewsPG(this.state.tabIndex, 1);
//     }
//     else if (e.target.name == 'searchReviewText' && !e.target.value) {
//       this.state.items = [];
//       this.state.searchReviewText = '';
//       this.state.isDisabledTextBox = true;
//       this.setState(this.state);
//       this.getReviewsPG(this.state.tabIndex, 1);
//     }
//     else {
//       this.setState({ [e.target.name]: e.target.value });
//     }
//   }

//   //handleSelectAll for delete
//   handleSelectAll = (target) => {
//     if (this.state.items.length > 0) {
//       if (target == true) {
//         for (let i = 0; i < this.state.items.length; i++) {
//           const s = this.state.items[i];
//           let _index = this.state.delArry.findIndex(x => x._id == s._id);
//           if (_index == -1) {
//             this.state.delArry.push({
//               _id: s._id,
//               ia: target
//             });
//             this.setState(this.state);
//           }
//         }
//       }
//       else {
//         this.state.delArry = [];
//       }
//       this.state.allSel = target;
//       this.setState(this.state);
//     }
//   }

//   //render review div
//   renderReviews = () => {
//     let { items, allSel } = this.state;
//     return <div className="visitor-data-content table-responsive">
//       <table className="table tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-webllist">
//         <thead className="thead-light">
//           <tr>
//             <th> <div className="table-userdata-checkboc">
//               <div className="secstyle-checkbox  userdata-icon-checkboc" style={{ top: '-4px', left: '-5px' }}>
//                 <label><input type="checkbox" checked={allSel} onChange={(e) => this.handleSelectAll(e.target.checked)} /></label>
//               </div>
//             </div></th>
//             <th className="tbl-no-col">No.</th>
//             <th className="text-nowrap">User Name</th>
//             <th className="text-nowrap">Ratings</th>
//             <th className="text-nowrap">Ratings Text</th>
//             <th className="text-nowrap">Source</th>
//             <th className="text-nowrap">Date</th>
//             <th className="text-nowrap">Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {this.state.isLoading == true ?
//             <tr>
//               <td colSpan="8">
//                 {Array(8)
//                   .fill('')
//                   .map((e, i) => (
//                     <TableRow key={i} style={{ opacity: Number(2 / i).toFixed(1) }} />
//                   ))}
//               </td>
//             </tr> :
//             items && items.length > 0 ?
//               items.map((obj, i) => {
//                 let { msg, rtng, un, fa, insdt, _id } = obj;
//                 if (_id == this.state._id) {
//                   obj.un = this.state.un;
//                   obj.fn = this.state.fn;
//                   obj.ln = this.state.ln;
//                   obj.msg = this.state.msg;
//                   obj.rtng = this.state.rtng;
//                 }
//                 let mulSelect = false;
//                 if (this.state.delArry.length > 0) {
//                   for (let i = 0; i < this.state.delArry.length; i++) {
//                     const d = this.state.delArry[i];
//                     if (obj._id == d._id) {
//                       mulSelect = true;
//                     }
//                   }
//                 }
//                 return (
//                   <tr key={i + 1}>
//                     <td>
//                       <div className="table-userdata-checkboc">
//                         <div className="secstyle-checkbox  userdata-icon-checkboc" style={{ top: '-4px', left: '-5px' }}>
//                           <label><input type="checkbox" checked={mulSelect} onChange={(e) => this.deleteMulti(obj._id, e.target.checked)} /></label>
//                         </div>
//                       </div>
//                     </td>
//                     <td>{i + 1}</td>
//                     <td>{un ? un : '-'}</td>
//                     <td>{rtng}</td>
//                     <td>{msg ? msg : '-'}</td>
//                     <td>{fa}</td>
//                     <td className="td-15x">{new Date(insdt).toLocaleString()}</td>
//                     <td>
//                       <div className="signup-data-action">
//                         <button className="nf-btn btn-edit" onClick={() => this.opReviewModel(obj)}>Edit</button>
//                         <span className="nf-btn  btn-delete-light  light-bg-icon btn-icon-30" onClick={() => this.deleteReviewData(obj._id)}><img src={IconDelete} alt="" /></span>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })
//               :
//               <tr>
//                 <td colSpan="11" className="text-center">
//                   <div className="clearfix"></div>
//                   <div className="nodata-block">
//                     <div className="nodata-box">
//                       <img src={NoDataImg} alt="No data" />
//                       <h4>Looks like there isn't any reviews data to show yet.</h4>
//                     </div>
//                   </div>
//                 </td>
//               </tr>
//           }
//           {this.state.hasMore == true && this.state.isLoading == false &&
//             <tr>
//               <td colSpan="8" style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => this.getReviewsPG(this.state.tabIndex, this.state.pgNum + 1)}>
//                 {this.state.pagingCount} record displayed out of {this.state.noOfRecord} records
//                 <a className="text-primary" style={{ textDecoration: 'none' }}> Load more</a>
//               </td>
//             </tr>
//           }
//         </tbody>
//       </table>
//     </div>;
//   }

//   handleEventForSearchByDate = (event, pickerDate) => {
//     if (event.handleObj.type == 'apply') {
//       if (new Date(pickerDate.startDate) && new Date(pickerDate.endDate)) {
//         this.state.startDate = new Date(pickerDate.startDate);
//         this.state.endDate = new Date(pickerDate.endDate);
//         this.state.items = [];
//         this.state.pagingCount = 0;
//         this.state.noOfRecord = 0;
//         this.state.tabIndex = 2;
//         let fromApp = searchQRY['fa'];
//         this.state.isDisabledTextBox = true;
//         searchQRY = {};
//         searchQRY = {
//           pageNo: 1,
//           fa: fromApp,
//           searchUsername: this.state.searchUsername ? this.state.searchUsername : '',
//           searchReviewText: this.state.searchReviewText ? this.state.searchReviewText : '',
//           custom: {
//             from: this.state.startDate ? this.state.startDate : '',
//             to: this.state.endDate ? this.state.endDate : ''
//           }
//         };
//         this.setState(this.state);
//         this.props.getReviews(searchQRY);
//       }
//     }
//   }

//   renderDate = () => {
//     if (this.state.startDate && this.state.endDate) {
//       return <DateRangePicker
//         onEvent={this.handleEventForSearchByDate}
//         maxDate={moment(new Date(new Date().setDate(new Date().getDate() - 1))).format('MM-DD-YYYY')}
//         startDate={this.state.startDate}
//         endDate={this.state.endDate}
//       >
//         Custom Date</DateRangePicker>;
//     }
//     else {
//       return <DateRangePicker
//         onEvent={this.handleEventForSearchByDate}
//         maxDate={moment(new Date(new Date().setDate(new Date().getDate() - 1))).format('MM-DD-YYYY')}
//       >Custom Date</DateRangePicker>;
//     }
//   }

//   getSelectedDataSource = (chipsArr) => {
//     let arrFuid = [];
//     this.state.items = [];
//     this.state.isDisabledTextBox = true;
//     this.state.pagingCount = 0;
//     this.state.noOfRecord = 0;
//     searchQRY = {};
//     searchQRY = {
//       pageNo: 1,
//       searchUsername: this.state.searchUsername ? this.state.searchUsername : '',
//       searchReviewText: this.state.searchReviewText ? this.state.searchReviewText : '',
//       custom: {
//         from: this.state.startDate ? this.state.startDate : '',
//         to: this.state.endDate ? this.state.endDate : ''
//       }
//     };
//     searchQRY['today'] = {};
//     searchQRY['custom'] = {};
//     if (this.state.tabIndex == 0) {
//       searchQRY['today'] = {
//         from: new Date().setHours(0, 0, 0, 0),
//         to: new Date().setHours(24, 0, 0, 0)
//       };
//     }
//     else if (this.state.tabIndex == 2) {
//       searchQRY['custom'] = {
//         from: this.state.startDate ? this.state.startDate : '',
//         to: this.state.endDate ? this.state.endDate : ''
//       };
//     }
//     if (chipsArr && chipsArr.length > 0) {
//       this.setState({ chipsData: chipsArr });
//       for (let i = 0; i < chipsArr.length; i++) {
//         arrFuid.push({ fuid: chipsArr[i].value });
//       }
//       searchQRY['fa'] = arrFuid;
//     }
//     else {
//       this.state.chipsData = '';
//       searchQRY['fa'] = '';
//     }
//     this.setState(this.state);
//     this.props.getReviews(searchQRY);
//   }

//   render() {
//     let dataSourceOption = [];
//     if (this.props.userIntegration && this.props.userIntegration.length > 0) {
//       this.props.userIntegration.map((userInt) => {
//         let intName = userInt.inm;
//         if (userInt.rmk) {
//           intName = userInt.inm + ' | ' + userInt.rmk;
//         }
//         dataSourceOption.push({
//           label: intName,
//           value: userInt._id
//         });
//       });
//     }
//     return (
//       <div className="main-container visitor-container" >
//         <div className="visitor-content">
//           <div className="">
//             <div className="page-content-topbar analytic-topbar visitor-topbar">
//               <div className="topbar-left">
//                 <div className="tab-same tab-analytic-block">
//                   <ul className="tab-same-list tab-analytic-list">
//                     <li className={this.state.tabIndex === 0 ? 'active' : ''} onClick={() => this.getReviewsPG(0, 1)}>Today</li>
//                     <li className={this.state.tabIndex === 1 ? 'active' : ''} onClick={() => this.getReviewsPG(1, 1)}>All Review</li>
//                     <li className={this.state.tabIndex === 2 ? 'active' : ''}>
//                       {this.renderDate()}
//                     </li>
//                     <input type="text"
//                       className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-mainvisitor"
//                       name="searchUsername"
//                       placeholder="Search by Username"
//                       onKeyPress={(e) => this.searchReview(e)}
//                       onChange={(e) => this.handleStateChange(e)}
//                       disabled={this.state.isDisabledTextBox} />
//                     <input type="text"
//                       className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-mainvisitor"
//                       name="searchReviewText"
//                       placeholder="Search by Review Text"
//                       onKeyPress={(e) => this.searchReview(e)}
//                       onChange={(e) => this.handleStateChange(e)}
//                       disabled={this.state.isDisabledTextBox} />
//                   </ul>
//                 </div>
//               </div>
//             </div>
//             <div className="clearfix"></div>
//             <div className="integration-chips-siupdata integration-chips integration-select-chips">
//               <div className="integration-data-select">
//                 {this.props.userIntegration && this.props.userIntegration.length > 0 &&
//                   <ReactMultiSelectCheckboxes
//                     options={dataSourceOption}
//                     onChange={this.getSelectedDataSource}
//                     placeholderButtonLabel='Select data source'
//                   />
//                 }
//               </div>
//             </div>
//             <div>
//               <div className="analytic-data-content">
//                 {
//                   this.state.delArry.length > 0 &&
//                   <div className="top-delete-option">
//                     <button className="nf-btn btn-delete-all" onClick={() => this.deleteBulk()}>
//                       Delete All
//                     </button>
//                     {/* <span className="nf-btn  btn-delete-light  light-bg-icon btn-icon-30"><img src={IconDelete} alt="" /></span> */}
//                   </div>
//                 }
//                 {this.renderReviews()}
//               </div>
//             </div>
//             {this.state.ocReview == true &&
//               <ReviewModel
//                 data={this.state}
//                 closeModal={this.closeModal}
//                 handleStateChange={this.handleStateChange}
//                 updateReview={this.updateReview}
//               />
//             }
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// const mapStateToProps = state => ({
//   loading: state.getIn(['loading', 'state']),
//   reviewsData: state.getIn(['reviews', 'reviewsData']),
//   userIntegration: state.getIn(['reviews', 'userIntegration']),
// });

// const mapDispatchToProps = {
//   getReviews, updateReview, deleteReviewData, deleteBulkReview, getUserIntegration
// };

// export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Review);


// WEBPACK FOOTER //
// ./src/containers/Review/Review.js